import request from './request';

//获取轮播图
export function slideList(params) {
    return request({
        url: 'pcIndex/lists',
        method: 'get',
        params
    })
}


export function webMenu(params) {
    return request({
        url: 'WebMenu/lists',
        method: 'get',
        params
    })
}

// 获取备案信息
export function getCopyright() {
    return request({
        url: 'WebSetting/getCopyright',
        method: 'get'
    })
}

// 获取网站基本信息
export function getWebsiteBase() {
    return request({
        url: 'WebSetting/getWebsiteBase',
        method: 'get'
    })
}

// 获取页面配置
export function getWebsite(params) {
    return request({
        url: 'WebSetting/getWebsite',
        method: 'get',
        params
    })
}

// 获取二级页面相关内容  
// 1：展会介绍
// 2：展位图
// 3：展商手册
// 4：展会安排
// 5：商旅服务
// 6：会议赞助
// 7：医药原材料
export function webAbout(params) {
    return request({
        url: 'webAbout/detail',
        method: 'get',
        params
    })
}

// 获取合作伙伴
export function getPartner() {
    return request({
        url: 'partner/lists',
        method: 'get'
    })
}

// 获取联系我们
export function contactsList(params) {
    return request({
        url: 'boothSales/lists',
        method: 'get',
        params
    })
}

// 获取历届回顾
export function reviewList() {
    return request({
        url: 'pcReview/lists',
        method: 'get'
    })
}

// 获取历届回顾情列表
export function reviewDetail(params) {
    return request({
        url: 'pcReview/detail',
        method: 'get',
        params
    })
}

// 获取新闻资讯列表
export function articleList(params) {
    return request({
        url: 'information/lists',
        method: 'get',
        params
    })
}

// 获取新闻资讯详情列表
export function articleDetail(params) {
    return request({
        url: 'information/detail',
        method: 'get',
        params
    })
}

// 获取往届会议嘉宾列表
export function guestsList(params) {
    return request({
        url: 'pcGuests/lists',
        method: 'get',
        params
    })
}
// 获取线上课程列表
export function onlineCourseList(params) {
    return request({
        url: 'onlineCourse/lists',
        method: 'get',
        params
    })
}

// 获取线上会议列表
export function offlineMeetList(params) {
    return request({
        url: 'offlineMeet/lists',
        method: 'get',
        params
    })
}
// 获取线上会议详情
export function offlineMeetDetail(params) {
    return request({
        url: 'offlineMeet/detail',
        method: 'get',
        params
    })
}

// 活动分类
export function categroyLists() {
    return request({
        url: 'activity/categroyLists',
        method: 'get'
    })
}

//获取活动列表
export function activityList(params) {
    return request({
        url: 'activity/lists',
        method: 'get',
        params
    })
}

//获取活动时间
export function timeLists(params) {
    return request({
        url: 'activity/timeLists',
        method: 'get',
        params
    })
}

//获取活动详情
export function activityDetail(params) {
    return request({
        url: 'activity/detail',
        method: 'get',
        params
    })
}

//获取联动菜单
export function getLinkage(params) {
    return request({
        url: 'public/getLinkage',
        method: 'get',
        params
    })
}


//网站登录
export function login(data) {
    return request({
        url: 'login/account',
        method: 'post',
        data
    })
}

//发送验证码
export function sendCode(data) {
    return request({
        url: 'login/send_pcode',
        method: 'post',
        data
    })
}

//获取个人信息
export function userInfo() {
    return request({
        url: 'user/info',
        method: 'get',
    })
}

// 修改用户信息
export function updateInfo(data) {
    return request({
        url: 'user/updateInfo',
        method: 'post',
        data
    })
}

// 收藏
// type 1:产品  2：展商 3：活动 4：商机
// status 0：取消收藏  1：收藏
export function collect(data) {
    return request({
        url: `user/collect`,
        method: 'post',
        data
    })
}

// 展商认证
export function companyAttestation(data) {
    return request({
        url: 'user/company_attestation',
        method: 'post',
        data
    })
}


// 获取收藏列表
export function collectList(params) {
    return request({
        url: 'user/collectLists',
        method: 'get',
        params
    })
}

// 获取下载中心列表
export function downloadCenter(params) {
    return request({
        url: 'fileShare/lists',
        method: 'get',
        params
    })
}

// 获取展商届次
export function sessionLists(params) {
    return request({
        url: 'session/lists',
        method: 'get',
        params
    })
}

// 获取字段选项
export function getBoxOption(data) {
    return request({
        url: 'public/getBoxOption',
        method: 'post',
        data
    })
}

//退出登录
export function logout() {
    return request({
        url: 'login/logout',
        method: 'get',
    })
}

// 意见反馈
export function opinion(data) {
    return request({
        url: 'user/opinion',
        method: 'post',
        data
    })
}

// 获取隐私协议
export function getAgreement() {
    return request({
        url: 'WebSetting/getAgreement',
        method: 'get',
    })
}

//******************************************************** */





// 获取字典
// 人员规模 staff_size_arr
// 企业性质 enterprise_nature_arr
// 企业经营类型 enterprise_type_arr
// 展位类型 booth_type
// 产品体系 product_structure
// 产品认证 product_authentication
// 产品标签 product_label
export function dict_lists(params) {
    return request({
        url:'dict/lists',
        method: 'get',
        params
    })
}




//获取参展类型 1:展商类型  2:观众类型
export function webExhibitionType(params) {
    return request({
        url: 'webExhibitionType/lists',
        method: 'get',
        params
    })
}

//获取活动类型
export function ActivityCate() {
    return request({
        url: 'ActivityCate/lists',
        method: 'get',
    })
}




// 展商认证
export function uploadImage(data) {
    return request({
        url: 'Upload/image',
        method: 'POST',
        data
    })
}


// 获取我的商机
export function publishList() {
    return request({
        url: 'need/mylists',
        method: 'get'
    })
}

// 获取我的应答
export function replyList() {
    return request({
        url: 'need_reply/mylists',
        method: 'get'
    })
}

// 获取我的索样／我的留言
export function consultationList(params) {
    return request({
        url: 'SeekSample/mylists',
        method: 'get',
        params
    })
}

// 线上会议板块列表
export function plateLists(params) {
    return request({
        url: 'offlineMeet/plateLists',
        method: 'get',
        params
    })
}

// 线上会议板块时间
export function offlineMeetTimeLists(params) {
    return request({
        url: 'offlineMeet/timeLists',
        method: 'get',
        params
    })
}


